module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-saved-for-later"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.saved_rewards.nav_space'),
      "backButton": "true"
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-saved-for-later__main"
  }, [_c('search-bar'), _vm._v(" "), _c('section', {
    staticClass: "c-page-header"
  }, [_c('div', {
    staticClass: "c-page-header__left"
  }, [_c('h1', {
    staticClass: "c-page-header__left__title"
  }, [_c('i', {
    staticClass: "fa fa-heart t-icon-primary-color"
  }), _vm._v("\n          " + _vm._s(_vm.$t('web.saved_rewards.page_header')) + "\n        ")])])]), _vm._v(" "), _vm._l((_vm.savedRewards), function(item) {
    return _c('section', {
      staticClass: "c-card c-card--saved-reward qa-saved-item"
    }, [_c('div', {
      staticClass: "c-card--saved-reward__details"
    }, [(item.available) ? _c('router-link', {
      staticClass: "c-card--saved-reward__details__img",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [(item.image && item.image['350x350']) ? _c('img', {
      attrs: {
        "src": item.image['350x350']
      }
    }) : _c('img', {
      attrs: {
        "src": "/img/thm350.png"
      }
    })]) : _vm._e(), _vm._v(" "), (!item.available) ? _c('span', {
      staticClass: "c-card--saved-reward__details__img\n                   c-card--saved-reward__details__img--no-hover",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [(item.image && item.image['350x350']) ? _c('img', {
      attrs: {
        "src": item.image['350x350']
      }
    }) : _c('img', {
      attrs: {
        "src": "/img/thm350.png"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "c-card--saved-reward__details__info"
    }, [(item.available) ? _c('router-link', {
      staticClass: "c-card--saved-reward__details__info__title\n                     t-link\n                     qa-saved-item-title",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]) : _vm._e(), _vm._v(" "), (!item.available) ? _c('span', {
      staticClass: "c-card--saved-reward__details__info__title\n                     qa-saved-item-title",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]) : _vm._e(), _vm._v(" "), (item.available) ? _c('div', {
      staticClass: "c-card--saved-reward__details__info__points"
    }, [_c('i', {
      staticClass: "fa fa-star t-points-icon"
    }), _vm._v(" "), _c('vue-numeric', {
      attrs: {
        "separator": ",",
        "read-only": true
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!item.available) ? _c('div', {
      staticClass: "c-card--saved-reward__details__info__removed"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('web.saved_rewards.item_unavailabe')) + "\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "c-card--saved-reward__buttons"
    }, [_c('button', {
      staticClass: "c-card--saved-reward__buttons__button\n                        c-button\n                        t-button-plain\n                        qa-remove-saved-item",
      attrs: {
        "disabled": _vm.deleteProcessing
      },
      on: {
        "click": function($event) {
          return _vm.deleteItem(item.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('web.saved_rewards.remove_item')) + "\n        ")]), _vm._v(" "), (item.available) ? _c('router-link', {
      staticClass: "c-card--saved-reward__buttons__button c-button t-button-plain",
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: item.ro_id
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('web.saved_rewards.go_to_item')) + "\n        ")]) : _vm._e()], 1)])
  })], 2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba064e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SavedRewards.vue
// module id = 533
// module chunks = 1